// removed by extract-text-webpack-plugin
module.exports = {"copy":"src-components-section-message----section-message-module---copy---3v6ER","copySecondary":"src-components-section-message----section-message-module---copySecondary---XftOD","wrapper":"src-components-section-message----section-message-module---wrapper---2TbUv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/section-message/section-message.module.css
// module id = 541
// module chunks = 168707334958949